import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c3ce2d80"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "banner-content" }, " 少儿编程一般针对青少年设计的编程模式，把原来复杂的英文代码编程语言转换成图形化的语言，以指令化，模块化方式让游戏，情景动画，积木构件的形式呈现。 ", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Banner = _resolveComponent("Banner")!
  const _component_WhyPower = _resolveComponent("WhyPower")!
  const _component_WhyForm = _resolveComponent("WhyForm")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_Banner, {
      title: "为什么选择编程",
      image: _ctx.bannerBg,
      class: "banner-wrap"
    }, {
      default: _withCtx(() => [
        _hoisted_1
      ]),
      _: 1
    }, 8, ["image"]),
    _createVNode(_component_WhyPower),
    _createVNode(_component_WhyForm)
  ]))
}